export const COOKIE_CONSENT_KEY = 'billwave_cookie_consent';
export const CURRENT_COOKIE_VERSION = 1;

export const DEFAULT_CONSENT = {
  version: CURRENT_COOKIE_VERSION,
  necessary: true,
  analytics: true,
  updatedAt: null,
};

export const DEFAULT_NECESSARY_ONLY_CONSENT = {
  version: CURRENT_COOKIE_VERSION,
  necessary: true,
  analytics: false,
  updatedAt: null,
};

export const COOKIE_CATEGORIES = [
  {
    id: 'necessary',
    name: '必要なCookie',
    description: 'ユーザー認証、セッション管理、CSRF対策、ログイン状態保持など、本サービスの正常な動作に必須となるCookieです。',
    required: true,
  },
  {
    id: 'analytics',
    name: '解析Cookie',
    description: 'アクセス解析ツールにより、サービスの利用状況を分析して品質向上に役立てるCookieです。',
    required: false,
  },
];
